import { useState } from "react";

export interface CartDrawerState {
  open: boolean;
}

/**
 * Hook for cart drawer state — used on tablet/mobile to show/hide reservation sidebar
 */
export const useCartDrawerState = () => {
  const [cartDrawerState, setCartDrawerState] = useState<CartDrawerState>({
    open: false,
  });

  // if passed object doesn't have .target attribute, it is a Backend entity (not an event)
  const handleOpenCartDrawer = () => {
    document.documentElement.classList.add("is-cart-drawer-opened");

    setCartDrawerState({ open: true });
  };
  const handleCloseCartDrawer = () => {
    document.documentElement.classList.remove("is-cart-drawer-opened");
    setCartDrawerState({ open: false });
  };

  return { cartDrawerState, handleOpenCartDrawer, handleCloseCartDrawer };
};
